import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";

export default function Dashboard() {
  const { data: stats = {} } = useQuery({ queryKey: ["admin-stats"], queryFn: async () => (await api.get("/admin/stats")).data });
  const cards = [
    ["Leads Masuk", stats.leads], ["Layanan", stats.services], ["Portfolio", stats.portfolio],
    ["Artikel Published", stats.posts_published], ["Artikel Draft", stats.posts_draft],
  ];
  return (
    <div data-testid="admin-dashboard">
      <h1 className="font-display font-black tracking-tightest text-3xl md:text-4xl mb-2">Dashboard</h1>
      <p className="text-sm text-muted-foreground mb-10">Ringkasan konten dan lead Digitalis.</p>
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-px bg-border border border-border">
        {cards.map(([label, val]) => (
          <div key={label} className="bg-background p-6">
            <div className="font-display font-black text-4xl">{val ?? "–"}</div>
            <p className="overline text-[10px] text-muted-foreground mt-2">{label}</p>
          </div>
        ))}
      </div>
      <div className="mt-10 border border-border p-6 bg-secondary/40">
        <h2 className="font-display font-bold text-lg mb-2">Selamat datang 👋</h2>
        <p className="text-sm text-muted-foreground">Gunakan menu di samping untuk mengedit konten website. Setiap perubahan yang Anda simpan langsung tampil di website publik.</p>
      </div>
    </div>
  );
}
